import dayjs, { Dayjs } from 'dayjs'

const MIN_DATE_ERROR_AFTER_EFFECTIVE = 'Expiration date must be after effective date'
const MIN_DATE_ERROR_FUTURE = 'Expiration date should be at least 1 day in the future'

export function getExpirationMinDate(effectiveAt: string | null | undefined): {
  minDate: Dayjs
  minDateError: string
} {
  const tomorrow = dayjs().add(1, 'day')
  const effectivePlusOne = effectiveAt ? dayjs(effectiveAt).add(1, 'day') : null

  if (effectivePlusOne?.isAfter(tomorrow)) {
    return {
      minDate: effectivePlusOne,
      minDateError: MIN_DATE_ERROR_AFTER_EFFECTIVE,
    }
  }

  return {
    minDate: tomorrow,
    minDateError: MIN_DATE_ERROR_FUTURE,
  }
}
